import axios from 'axios'

// This module is loaded lazily (with the Feedback route), so the instance is
// usually created after login and create() snapshots the global defaults at that
// moment. The snapshot would carry the user's Authorization header to the Mautic
// marketing host, so removing it is load-bearing, not defensive. The inherited
// Content-Type (application/x-www-form-urlencoded, set in main.js) is required
// by Mautic.
export const mautic = axios.create({timeout: 60000})
delete mautic.defaults.headers.common.Authorization

export default {
  send(data)
  {
    // Per-environment endpoint: a dev or staging build must not write records into
    // the production marketing system. apiHelper is not used because it would
    // prefix the URL with VUE_APP_API_BASE_URL.
    const url = process.env.VUE_APP_MAUTIC_FORM_URL
    if (!url)
    {
      return Promise.reject(new Error('VUE_APP_MAUTIC_FORM_URL is not configured'))
    }
    return mautic.post(url, data)
  }
}
